import { useEffect } from "react"

export const useClickListener = (callback) => {
    useEffect(() => {
        window.addEventListener("click", callback);
        return () => window.removeEventListener("click", callback);
    }, [callback]);
};
